import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaTrash, FaArrowUp, FaArrowDown, FaWallet, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { toast } from 'react-toastify';
import cashService from '../services/cashService';

const CashPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [summary, setSummary] = useState({ total_in: 0, total_out: 0, balance: 0 });
  const [loading, setLoading] = useState(true);
  const [expandedRow, setExpandedRow] = useState(null);

  const fetchData = async () => {
    try {
      const [txData, summaryData] = await Promise.all([
        cashService.getAll(),
        cashService.getSummary()
      ]);
      setTransactions(txData);
      setSummary(summaryData);
    } catch (error) {
      toast.error('Veriler yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleRow = (id) => setExpandedRow(expandedRow === id ? null : id);

  const handleDelete = async (id) => {
    if (window.confirm('Bu işlemi silmek istediğinize emin misiniz?')) {
      try {
        await cashService.delete(id);
        toast.success('İşlem silindi.');
        fetchData(); // Listeyi ve özeti güncelle
      } catch (error) {
        toast.error('Silme işlemi başarısız.');
      }
    }
  };

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Kasa Takibi</h2>
        <Link to="/cash/new" className="btn btn-primary">
          <FaPlus className="me-2" /> Yeni İşlem Ekle
        </Link>
      </div>

      {/* Özet Kartları */}
      <div className="row mb-4">
        <div className="col-md-4">
          <div className="card text-white bg-success mb-3">
            <div className="card-body d-flex align-items-center justify-content-between">
              <div>
                <h6 className="card-title">Toplam Giriş</h6>
                <h4 className="fw-bold">
                  {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(summary.total_in)}
                </h4>
              </div>
              <FaArrowUp size={30} className="opacity-50" />
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card text-white bg-danger mb-3">
            <div className="card-body d-flex align-items-center justify-content-between">
              <div>
                <h6 className="card-title">Toplam Çıkış</h6>
                <h4 className="fw-bold">
                  {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(summary.total_out)}
                </h4>
              </div>
              <FaArrowDown size={30} className="opacity-50" />
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card text-white bg-info mb-3">
            <div className="card-body d-flex align-items-center justify-content-between">
              <div>
                <h6 className="card-title">Net Bakiye</h6>
                <h4 className="fw-bold">
                  {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(summary.balance)}
                </h4>
              </div>
              <FaWallet size={30} className="opacity-50" />
            </div>
          </div>
        </div>
      </div>

      {/* Hareket Listesi */}
      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <h5 className="mb-0">Son Hareketler</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive d-none d-md-block">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th>Açıklama</th>
                  <th>Tip</th>
                  <th>Tutar</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((tx) => (
                  <tr key={tx.id}>
                    <td>{new Date(tx.transaction_date).toLocaleDateString('tr-TR')}</td>
                    <td>{tx.description}</td>
                    <td>
                      <span className={`badge ${tx.transaction_type === 'giris' ? 'bg-success' : 'bg-danger'}`}>
                        {tx.transaction_type === 'giris' ? 'Giriş' : 'Çıkış'}
                      </span>
                    </td>
                    <td className={tx.transaction_type === 'giris' ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                      {tx.transaction_type === 'giris' ? '+' : '-'} 
                      {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(tx.amount)}
                    </td>
                    <td>
                      <button onClick={() => handleDelete(tx.id)} className="btn btn-sm btn-outline-danger">
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
                {transactions.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center">Kayıtlı işlem bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobil Görünüm */}
          <div className="d-md-none">
            {transactions.map((tx) => (
              <div className="card mb-3 shadow-sm" key={tx.id}>
                <div className="card-body" onClick={() => toggleRow(tx.id)} style={{ cursor: 'pointer' }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-0 fw-bold">{tx.description}</h6>
                      <span className={`badge ${tx.transaction_type === 'giris' ? 'bg-success' : 'bg-danger'}`}>
                        {tx.transaction_type === 'giris' ? 'Giriş' : 'Çıkış'}
                      </span>
                    </div>
                    <div className="text-end">
                      <div className={tx.transaction_type === 'giris' ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                        {tx.transaction_type === 'giris' ? '+' : '-'} 
                        {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(tx.amount)}
                      </div>
                      <small className="text-muted">{expandedRow === tx.id ? <FaChevronUp /> : <FaChevronDown />}</small>
                    </div>
                  </div>

                  {expandedRow === tx.id && (
                    <div className="mt-3 border-top pt-3">
                      <p className="mb-1"><strong>Tarih:</strong> {new Date(tx.transaction_date).toLocaleDateString('tr-TR')}</p>
                      <div className="d-flex justify-content-end gap-2 mt-3">
                        <button onClick={(e) => { e.stopPropagation(); handleDelete(tx.id); }} className="btn btn-sm btn-outline-danger">
                          <FaTrash /> Sil
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashPage;